

















import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
})
export default class Tooltip extends Mixins() {
  @Prop()
  content: string;

  @Prop()
  placement: string;

  @Prop({ default: -1 })
  tabindex: number;

  data(): any {
    return {
      isVisible: true,
      monitoringTimer: null as NodeJS.Timer,
      effect: "dark",
      openDelay: 1000,
      hideAfter: 7000,
    };
  }
  isVisible: boolean;
  monitoringTimer: NodeJS.Timer;
  effect: string;
  openDelay: number;
  hideAfter: number;

  get hasContentSlot(): boolean {
    return !!this.$slots.content;
  }

  get disabled(): boolean {
    return (!this.hasContentSlot && (!this.content || (this.content === "")));
  }

  onInput(value: boolean): void {
    if (value) {
      this.monitoringTooltip();
    } else {
      this.releaseMonitoring();
    }
  }

  private monitoringTooltip(): void {
    if (this.invalidDisplay()) {
      this.reloadTooltip();
    } else {
      this.monitoringTimer = setTimeout(this.monitoringTooltip, 100);
    }
  }

  private invalidDisplay(): boolean {
    if (!(this.$el instanceof Element)) {
      return true;
    }
    const rect = this.$el.getBoundingClientRect();
    return rect.top === 0 && rect.left === 0 && rect.bottom === 0 && rect.right === 0;
  }

  private reloadTooltip(): void {
    this.isVisible = false;
    this.$nextTick(() => this.isVisible = true);
  }

  private releaseMonitoring(): void {
    if (!!this.monitoringTimer) {
      clearTimeout(this.monitoringTimer);
    }
  }
}
